import { Injectable } from '@angular/core';
import { PagedAndSortedRequestDto } from '@shared/components/paged-listing-component-base';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { ServiceBase } from '../service-base';
import { InformationPopupDto, InformationPopupResultDto } from './information-popup-dto';
import { String } from 'typescript-string-operations';
import { ApiRequest } from "@shared/models/api-request";

@Injectable({
  providedIn: 'root'
})
export class InformationPopupService extends ServiceBase {
  public list(request: PagedAndSortedRequestDto): Observable<InformationPopupResultDto> {
    const apiUrl: string = this._appConstants.API.INFORMATION_POPUP.LIST;
    const apiRequest: ApiRequest = this._apiService.prepareInputSortAndSearchPage(apiUrl, request);

    return this._apiService.get(apiRequest.apiUrl).pipe(
      map((res: any) => {
        return new InformationPopupResultDto().deserialize({
          totalCount: res.count,
          items: res.results.map((item: InformationPopupDto) =>
            new InformationPopupDto().deserialize(item)
          ),
        });
      })
    );
  }

  public create(input: InformationPopupDto): Observable<InformationPopupDto> {
    const apiUrl: string = this._appConstants.API.INFORMATION_POPUP.ADD;
    return this._apiService.post(apiUrl, input)
    .pipe(map((item: Object) => new InformationPopupDto().deserialize(item)));
  }

  public update(input: InformationPopupDto): Observable<InformationPopupDto> {
    const apiUrl: string = String.Format(this._appConstants.API.INFORMATION_POPUP.UPDATE, input.id);

    return this._apiService.put(apiUrl, input)
    .pipe(map((item: Object) => new InformationPopupDto().deserialize(item)));
  }

  public delete(id: number): Observable<void | Object> {
    const apiUrl: string = String.Format(this._appConstants.API.INFORMATION_POPUP.DELETE, id);

    return this._apiService.delete(apiUrl).pipe(
      catchError((response_: any) => {
        return <Observable<void>>(<any>throwError(response_));
      })
    );
  }
}
